module.exports = __webpack_public_path__ + "img/acc.0c48b2ff.jpg";